export const COLLAPSE = 'COLLAPSE';
export const TOGGLE = 'TOGGLE';
export const COLLAPSE_ALL = 'COLLAPSE_ALL';